module.exports = __webpack_public_path__ + "static/media/6540.0bd4b47b.jpg";